import React from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import faker from 'faker';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

export const options = {
  responsive: true,
  plugins: {
    legend: {
      position: 'top',
    },
    title: {
      display: true,
      text: 'Returning vs First Time Users (%)',
    },
  },
};

const labels = ['March 2021', 'June 2021', 'September 2021', 'December 2021', 'March 2022', 'June 2022', 'September 2022', 'December 2022'];

export const data = {
  labels,
  datasets: [
    {
      label: 'Purchased First Time',
      data: labels.map(() => faker.datatype.number({ min: 32, max: 45 })),
      backgroundColor: 'lime',
    },
    {
      label: 'Returning Users',
      data: labels.map(() => faker.datatype.number({ min: 55, max: 68 })),
      backgroundColor: 'cyan',
    },
  ],
};
const ReturningVsFirstTimeChart = () => {
  return <Bar style={{boxShadow: "0 0 32px 2px turquoise", borderRadius:"15px"}} className="py-1 px-2 p-md-4 m-1 m-md-4" options={options} data={data} />;
}

export default ReturningVsFirstTimeChart